// Adapted from davinci-elections packages/shared/src/routes.ts @ 6e23f58
// Kept in its own file so route groups (api/*.ts) can import `route` without a cycle through routes.ts.
import type { z } from 'zod'

export type HttpMethod = 'GET' | 'POST' | 'PATCH' | 'DELETE'
export type RouteAuth = 'public' | 'admin' | 'member' | 'registration' | 'member_or_registration'

export interface RouteDef<
  M extends HttpMethod = HttpMethod,
  P extends string = string,
  Params extends z.ZodType | undefined = z.ZodType | undefined,
  Query extends z.ZodType | undefined = z.ZodType | undefined,
  Body extends z.ZodType | undefined = z.ZodType | undefined,
  Res extends z.ZodType = z.ZodType,
> {
  method: M
  path: P
  auth: RouteAuth
  params: Params
  query: Query
  body: Body
  response: Res
}

export const route = <
  M extends HttpMethod,
  P extends string,
  Res extends z.ZodType,
  Params extends z.ZodType | undefined = undefined,
  Query extends z.ZodType | undefined = undefined,
  Body extends z.ZodType | undefined = undefined,
>(def: {
  method: M
  path: P
  auth: RouteAuth
  response: Res
  params?: Params
  query?: Query
  body?: Body
}): RouteDef<M, P, Params, Query, Body, Res> => ({
  method: def.method,
  path: def.path,
  auth: def.auth,
  response: def.response,
  params: def.params as Params,
  query: def.query as Query,
  body: def.body as Body,
})
